import * as action from './actions';

import * as actionTypes from './actionTypes';

import { AUTH_TOKEN_NAME } from 'constants/api';

import { getCookie } from 'helpers/cookie';

import { InferValueTypes } from 'types/commonTypes';

interface AuthState {
    isAuthenticated: boolean;
    isComplete: boolean;
    redirectUrl: string | null;
    userSource: string | null;
    token: string | null;
}

const initialState: AuthState = {
    isAuthenticated: false,
    isComplete: false,
    redirectUrl: null,
    userSource: null,
    token: getCookie(AUTH_TOKEN_NAME) || null,
};

type ActionType = ReturnType<InferValueTypes<typeof action>>;

const userReducer = (state: AuthState = initialState, action: ActionType): AuthState => {
    switch (action.type) {
        case actionTypes.AUTHENTICATION_SUCCESS:
            return { ...state, isAuthenticated: true, isComplete: true };

        case actionTypes.AUTHENTICATION_FAILED:
            return { ...state, isAuthenticated: false, isComplete: true };

        case actionTypes.SET_AUTHENTICATION_STATUS:
            return { ...state, isAuthenticated: action.payload, isComplete: true };

        case actionTypes.LOG_OUT:
            return { ...state, isAuthenticated: false, isComplete: true };

        case actionTypes.SET_AUTHENTICATION_REDIRECT_URL:
            return { ...state, redirectUrl: action.payload };

        case actionTypes.SET_USER_SOURCE:
            return { ...state, userSource: action.payload };

        case actionTypes.SET_AUTH_TOKEN:
            return { ...state, token: action.payload };

        default:
            return state;
    }
};

export default userReducer;
